// frontend/src/services/commands/NestHubCommandService.js
import { CommandService } from './CommandService.js';

/**
 * Serwis komend specyficznych dla urządzeń NestHub
 */
export class NestHubCommandService extends CommandService {
  constructor(apiClient) {
    super(apiClient);
    this.deviceType = 'NestHub';
    this.basePath = '/devices/nesthub';
  }

  /**
   * Wykonaj komendę asynchronicznie na NestHub
   */
  async executeCommandAsync(deviceUuid, command, data, timeout) {
    return this.apiClient.post(`${this.basePath}/${deviceUuid}/execute/`, {
      command,
      data,
      timeout,
      async: true
    });
  }

  /**
   * Wykonaj komendę synchronicznie na NestHub
   */
  async executeCommandSync(deviceUuid, command, data, timeout) {
    return this.apiClient.post(`${this.basePath}/${deviceUuid}/execute/`, {
      command,
      data,
      timeout,
      async: false
    });
  }

  // === DISCOVERY COMMANDS ===
  
  /**
   * Pobierz listę drukarek z NestHub
   */
  async getPrinters(deviceUuid, options = {}) {
    return this.executeCommand(deviceUuid, 'get_printer_list', {}, options);
  }

  /**
   * Skanuj sieć w poszukiwaniu nowych drukarek
   */
  async scanForPrinters(deviceUuid, options = {}) {
    return this.executeCommand(deviceUuid, 'scan_network_printers', {}, options);
  }

  /**
   * Sprawdź status konkretnej drukarki
   */
  async checkPrinterStatus(deviceUuid, printerSerial, options = {}) {
    return this.executeCommand(deviceUuid, 'check_printer_status', { 
      printer_serial: printerSerial 
    }, options);
  }

  // === MAINTENANCE COMMANDS ===
  
  /**
   * Uruchom diagnostykę systemu
   */
  async runDiagnostics(deviceUuid, options = {}) {
    return this.executeCommand(deviceUuid, 'run_diagnostics', {}, options);
  }

  /**
   * Sprawdź aktualizacje oprogramowania
   */
  async checkUpdates(deviceUuid, options = {}) {
    return this.executeCommand(deviceUuid, 'check_updates', {}, options);
  }

  /**
   * Restartuj usługi NestHub
   */
  async restartServices(deviceUuid, options = {}) {
    return this.executeCommand(deviceUuid, 'restart_services', {}, options);
  }

  // === CONFIGURATION COMMANDS ===
  
  /**
   * Pobierz konfigurację urządzenia
   */
  async getConfiguration(deviceUuid, options = {}) {
    return this.executeCommand(deviceUuid, 'get_configuration', {}, options);
  }

  /**
   * Zaktualizuj konfigurację urządzenia
   */
  async updateConfiguration(deviceUuid, config, options = {}) {
    return this.executeCommand(deviceUuid, 'update_configuration', { config }, options);
  }

  // === MONITORING COMMANDS ===
  
  /**
   * Pobierz statystyki systemu
   */
  async getSystemStats(deviceUuid, options = {}) {
    return this.executeCommand(deviceUuid, 'get_system_stats', {}, options);
  }

  /**
   * Pobierz logi systemu
   */
  async getSystemLogs(deviceUuid, lines = 100, options = {}) {
    return this.executeCommand(deviceUuid, 'get_system_logs', { lines }, options);
  }
}
